import { create } from "zustand";

export const useStoreCRMAnalyse = create((set, get) => ({
  crmBulkAnalysePayload: [],
  crmBulkAnalyseData: [],
  isCRMBulkAnalyseLoading: true,
  isCRMBulkAnalyseFetched: false,

  // Set payload
  setCRMBulkAnalysePayload: (data) => {
    set({
      crmBulkAnalysePayload: data,
      isCRMBulkAnalyseLoading: data.length > 0,
      isCRMBulkAnalyseFetched: false,
      // crmBulkAnalyseData: [], // optional: reset data on new payload
    });
  },

  // Set entire data manually
  setCRMBulkAnalyseData: (data) => {
    set({
      crmBulkAnalyseData: data,
      isCRMBulkAnalyseLoading: data.length < get().crmBulkAnalysePayload.length,
      isCRMBulkAnalyseFetched: data.length === get().crmBulkAnalysePayload.length,
    });
  },

  // Add or update a chunk

  addChunkInCRMBulkAnalyseData: (chunk) => {
    const state = get();
    const existing = [...state.crmBulkAnalyseData];

    // Determine the ID key and value
    let idKey = "recordId";
    if (chunk.person_id) {
      idKey = "person_id";
    }
    if (chunk.contact_id) {
      idKey = "contact_id";
    }
    if (chunk.organization_id) {
      idKey = "organization_id";
    }
    if (chunk.crm_record_id) {
      idKey = "crm_record_id";
    }

    const idValue = chunk[idKey];

    console.log("chunk", chunk);

    // Find the index using any of the 3 ID types
    const index = existing.findIndex(
      (r) =>
        r.person_id === idValue ||
        r.contact_id === idValue ||
        r.recordId === idValue ||
        r.organization_id === idValue ||
        r.crm_record_id === idValue
    );

    const newEntry = {
      [idKey]: idValue,
      crm_record_id: chunk?.crm_record_id,
      data: chunk?.data,
      message: chunk?.message,
      status: chunk?.status,
    };

    if (index !== -1) {
      existing[index] = {
        ...existing[index],
        ...newEntry,
      };
    } else {
      existing.push(newEntry);
    }

    const isLoading = existing.length < state.crmBulkAnalysePayload.length;
    const isFetched = existing.length === state.crmBulkAnalysePayload.length;

    set({
      crmBulkAnalyseData: existing,
      isCRMBulkAnalyseLoading: isLoading,
      isCRMBulkAnalyseFetched: isFetched,
    });
  },

  // ✅ Get specific record by ID
  getCRMAnalyseRecordById: (id) => {
    const state = get();
    return state.crmBulkAnalyseData.find(
      (item) =>
        item.person_id === id ||
        item.contact_id === id ||
        item.recordId === id ||
        item.organization_id === id ||
        item.crm_record_id === id
    );
  },
}));
